module.exports = __webpack_public_path__ + "images/estimate_entry_banner/products_left_pc_f4d697bec617fbcbb637764814d3f8b1.svg";